<template>
  <v-container>
    <div class="home-container">
      <v-img
        :src="image_src"
        height="125"
        position="center 80%"
      >
        <div class="home-overlay">
          <div class="home-title">Recalls from the CPSC</div>
          <div class="cpsc">
            (<a href="https://www.cpsc.gov/" target="_blank" rel="noopener noreferrer">Consumer Product Safety Commission</a>)
          </div>
        </div>
      </v-img>
    </div>
    <recall-list></recall-list>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      image_src: require('../assets/office.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
  .home-container {

    @media (max-width: 960px) {
      padding: 16px;
    }

    @media only screen and (min-width: 960px) {
      padding: 8px 24px;
    }

    .home-overlay {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      height: 100%;
      align-content: center;
      color: #fff;
      text-shadow: 2px 4px 3px rgba(0,0,0,0.3);

      @media (max-width: 600px) {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      @media only screen and (min-width: 600px) {
        font-size: 1.75rem;
        line-height: 2.25rem;
      }

      @media only screen and (min-width: 960px) {
        font-size: 2rem;
        line-height: 2.5rem;
      }

      .home-title {
        text-transform: uppercase;
        letter-spacing: .15em;
      }

      div {
        flex: 1 0 100%;
      }

      div.cpsc {
        padding-top: 4px;

        @media (max-width: 600px) {
          font-size: 1rem;
          line-height: 1rem;
        }

        @media only screen and (min-width: 600px) {
          font-size: 1.25rem;
          line-height: 1.25rem;
        }

        @media only screen and (min-width: 960px) {
          font-size: 1.5rem;
          line-height: 1.5rem;
        }

        > a {
          color: #fff;
          text-decoration: none;
          font-style: italic;
        }
      }
    }
  }
</style>
